import React, { useEffect, useState } from "react";
import loading from "../../../../assets/media/loader/dual-ring.svg";
const ConfirmDelete = ({ id, setConfirmingDelete, deleteLink, deleting }) => {
  const [identical, setIdentical] = useState(false);
  const [input, setInput] = useState("");
  useEffect(() => {
    if (input === id) {
      setIdentical(true);
    } else setIdentical(false);
  }, [input]);
  const handleDropClick = async () => {
    if (!identical) return;
    deleteLink();
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center z-[999] w-screen h-screen bg-semi-trans backdrop-blur-sm">
      <div className="md:p-20px p-16px rounded-lg bg-white dark:bg-accent-600">
        {deleting ? (
          <img width={"30px"} src={loading} alt="" />
        ) : (
          <>
            <div className="mb-20px text-lg font-semibold text-accent-800 dark:text-accent-100">
              Delete link
            </div>
            <div className="flex flex-col gap-10px">
              <label
                className="text-accent-400 dark:text-accent-200"
                htmlFor="delete"
              >
                To drop the link{" "}
                <span className="text-primary-500 dark:text-primary-500 font-semibold">
                  {" "}
                  #{id}
                </span>
                , type <strong>{id}</strong> to confirm
              </label>
              <input
                className="text-accent-700 dark:text-accent-100 dark:bg-accent-700 dark:border-none w-full border border-accent-100 rounded-md py-2 px-10px font-bold focus-within:outline-primary-500 dark:focus-within:outline dark:focus-within:outline-primary-500"
                type="text"
                id="delete"
                placeholder="Type link's identifier"
                value={input}
                onChange={(e) => setInput(e.target.value)}
              />
            </div>
            <div className="flex mt-20px w-full justify-end gap-16px text-sm font-medium">
              <button
                type="button"
                className="bg-transparent border border-accent-100 rounded-lg px-12px py-[6px] text-accent-400 dark:border-accent-400 dark:text-accent-200 focus-within:outline-primary-500"
                onClick={() => setConfirmingDelete(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className=" bg-[#ff6969] dark:disabled:bg-accent-400 disabled:bg-accent-200 disabled:cursor-not-allowed text-white py-2 px-16px rounded-md"
                disabled={!identical}
                onClick={() => handleDropClick()}
              >
                Drop
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ConfirmDelete;
